import { COMPONENT_TYPES, COMPANY_HISTORY } from '../../../constants';
import CompanyHistoryComponent from './CompanyHistory.component';
import CompanyHistoryEditor from './CompanyHistory.editor';
import CompanyHistoryProperties from './CompanyHistory.properties';
import { registerComponent } from '../registry';
import { v4 as uuidv4 } from 'uuid';

// 레지스트리에 회사 연혁 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.COMPANY_HISTORY,
  component: CompanyHistoryComponent,
  editorComponent: CompanyHistoryEditor,
  properties: CompanyHistoryProperties,
  defaultProps: {
    title: '회사 연혁',
    subtitle: '저희 회사의 성장 과정을 소개합니다',
    timelineStyle: 'vertical',
    animation: true,
    colorScheme: {
      primary: '#3498db',
      secondary: '#f1c40f',
      background: '#ffffff',
      text: '#333333'
    },
    imageWidth: 150,
    imageHeight: 150,
    historyItems: [
      {
        id: uuidv4(),
        year: '2010',
        title: '회사 설립',
        description: '혁신적인 비전을 가지고 회사가 설립되었습니다.',
        image: ''
      },
      {
        id: uuidv4(),
        year: '2012',
        title: '첫 제품 출시',
        description: '시장에서 좋은 반응을 얻은 첫 제품을 출시했습니다.',
        image: ''
      },
      {
        id: uuidv4(),
        year: '2015',
        title: '해외 시장 진출',
        description: '글로벌 시장으로 확장하여 아시아 지역에 첫 해외 지사를 설립했습니다.',
        image: ''
      },
      {
        id: uuidv4(),
        year: '2018',
        title: '주요 투자 유치',
        description: '대규모 투자 유치에 성공하여 사업 확장의 기반을 마련했습니다.',
        image: ''
      },
      {
        id: uuidv4(),
        year: '2020',
        title: '기술 혁신상 수상',
        description: '혁신적인 기술력을 인정받아 국내 기술 혁신상을 수상했습니다.',
        image: ''
      },
      {
        id: uuidv4(),
        year: '2023',
        title: '신규 서비스 론칭',
        description: '고객 중심의 혁신적인 서비스를 성공적으로 출시했습니다.',
        image: ''
      }
    ],
    style: {
      padding: '40px 20px',
      maxWidth: '1200px',
      margin: '0 auto',
      fontFamily: 'Noto Sans KR, sans-serif',
    }
  },
  category: 'content',
  icon: '📜',
  name: '회사 연혁'
});

// 회사 연혁 컴포넌트 및 타입 내보내기
export { default as CompanyHistoryComponent } from './CompanyHistory.component';
export { default as CompanyHistoryEditor } from './CompanyHistory.editor';
export { default as CompanyHistoryProperties } from './CompanyHistory.properties';
export * from './CompanyHistory.types'; 